<!--Formulaire des généralités de l'abattement-->
<fieldset ngModelGroup="abattement-generalites">
    <mat-card>
        <!--Titre du bloc généralités-->
        <mat-card-title>
            <span [translate]="'admin.frais.indemnites.abattements.detail.generalites.title'"></span>
        </mat-card-title>

        <mat-card-content>
            <!--Ligne de sélection des référentiels de rattachement-->
            <div class="row">
                <!--Sélection de la règle d'attribution (horaire)-->
                <custom-input ngDefaultControl
                              name="idHoraire"
                              customType="select"
                              [lCol]="2"
                              [rCol]="4"
                              [(ngModel)]="abattement.idHoraire"
                              [selectOptions]="listeHorairesAvecTous"
                              optionValue="idHoraire"
                              optionDisplay="libelle"
                              libelle="admin.frais.indemnites.abattements.detail.generalites.regleAttribution">
                </custom-input>

                <!--Sélection du type d'entité concerné-->
                <custom-input ngDefaultControl
                              name="idTypeEntite"
                              customType="select"
                              [lCol]="2"
                              [rCol]="4"
                              [(ngModel)]="abattement.idTypeEntite"
                              [selectOptions]="listeTypesEntiteAvecTous"
                              optionValue="idTypeEntite"
                              optionDisplay="libelle"
                              libelle="admin.frais.indemnites.abattements.detail.generalites.typeEntite">
                </custom-input>
            </div>

            <!--Ligne de saisie des valeurs de calcul-->
            <div class="row">
                <!--Nombre minimal de jours d'application de l'abattement-->
                <custom-input ngDefaultControl
                              name="nbJours"
                              customType="number"
                              [lCol]="2"
                              [rCol]="4"
                              [(ngModel)]="abattement.nbJours"
                              [required]="true"
                              [min]="0"
                              [nbDecimales]="0"
                              libelle="admin.frais.indemnites.abattements.detail.generalites.nbJours">
                </custom-input>

                <!--Pourcentage d'abattement appliqué (borné entre 0 et 100)-->
                <custom-input ngDefaultControl
                              name="pourcentageAbattement"
                              customType="number"
                              [lCol]="2"
                              [rCol]="4"
                              [(ngModel)]="abattement.pourcentageAbattement"
                              [required]="true"
                              [nbDecimales]="2"
                              suffix="%"
                              libelle="admin.frais.indemnites.abattements.detail.generalites.abattement">
                </custom-input>
            </div>
        </mat-card-content>
    </mat-card>
</fieldset>
